module.exports = __webpack_public_path__ + "static/img/kb-card-app-contents-img-01.b047d87.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/kb-card/kb-card-app-contents-img-01.png
// module id = Q5nn
// module chunks = 0